import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "size", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
var SpotToysHobbiesComponent = _ref => {
  var {
      accessibilityLabel,
      id,
      size = 24,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'SpotToysHobbies',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, props), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1C84A0",
    d: "M8.3 3.373 3.38 8.294l10.86 10.861 4.922-4.921L8.3 3.373Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#28BBDD",
    d: "m21.532 16.605-2.42-2.42-4.92 4.92 2.42 2.42c.61.61 1.59.61 2.19 0l2.73-2.73c.6-.6.6-1.58 0-2.19ZM2.472 4.945l.9 3.36 2.46-2.46 2.46-2.46-3.36-.9-.06-.01-2.41 2.41.01.06Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1C84A0",
    d: "m2.472 4.865 2.39-2.39-1.54-.42c-.77-.21-1.47.5-1.27 1.27l.42 1.54Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#28BBDD",
    d: "M2.996 21.045a3.374 3.374 0 0 1 0-4.76l11.396-10.44 3.94 3.79-10.576 11.41a3.356 3.356 0 0 1-4.76 0Z"
  }), /*#__PURE__*/React.createElement(Shape, {
    fill: "#1C84A0",
    d: "M20.282 9.035c-.89 1.1-1.83.74-1.96.62-.12-.12-3.69-3.57-3.92-3.8-.23-.23-.47-2.01 2.03-3.44 1.71-.8 5.92-.26 5.43.69-1.92 2.38-.36 4.31-1.58 5.93Z"
  }));
};
SpotToysHobbiesComponent.displayName = 'SpotToysHobbies';
export var SpotToysHobbies = withProvisionalOverrideFromContext(SpotToysHobbiesComponent);
//# sourceMappingURL=index.js.map